import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import DisplayComponent from '../BaseComponents/DisplayComponent';

import './FullWidthImage.module.css';

class FullWidthImage extends PureComponent {
  render() {
    const { imageUrl, imageWidth, imageHeight } = this.props;

    let imageRatio = 50;
    if (imageHeight) {
      imageRatio = (imageHeight / imageWidth) * 100;
    }

    return (
      <div
        styleName="full-width-image"
        style={{
          backgroundImage: `url(${imageUrl})`,
          height: `${imageRatio}vw`
        }}
      />
    );
  }
}

FullWidthImage.propTypes = {
  imageUrl: PropTypes.string,
  imageWidth: PropTypes.number,
  imageHeight: PropTypes.number
};

export default DisplayComponent(FullWidthImage);
